<!--分享好友-->
<template>
	<div>
		<div class="bit-center-wrap customer-page">
			<div class="customer-top">
				<div class="customer-left-content">
					<h1>{{ $t('与您的朋友一起赚钱') }}</h1>
					<h4>{{ $t('从您邀请人的交易中分享高达20% 的佣金') }}</h4>
					<img src="@/assets/img-pc/invitation_1.png" alt="" />
				</div>
				<div class="customer-right-content">
					<div class="amount-row">
						<div class="title">{{ $t('邀请码') }}</div>
						<div class="desc">{{ quantity }}</div>
						<div class="svg-containe cur-poi">
							<i class="el-icon-document-copy" style="font-size: 23px;color: #fff;"
								@click="copyText(quantity)"></i>
						</div>
					</div>

					<div class="amount-row">
						<div class="title">{{ $t('邀请链接') }}</div>
						<div class="desc truncate1">{{ shareUrl }}</div>
						<div class="svg-containe cur-poi">
							<i class="el-icon-document-copy" style="font-size: 23px;color: #fff;"
								@click="copyText(shareUrl)"></i>
						</div>
					</div>

					<div class="create-qrcode" @click="show = true">
						<img src="@/assets/img-pc/invitation_2.png" alt="" class="icon-qrcode" />
						{{ $t('生成二维码') }}
					</div>
					<div class="tips-cont">{{ $t('我的邀请') }}</div>
					<section class="my-invite">
						<div><span class="amount">{{ source.invite_number }}</span><span>{{ $t('邀请人数') }}</span></div>
						<div><span class="amount">{{ source.invite_reward }}</span><span>{{ $t('总返佣') }}</span></div>
						<div><span class="amount">{{ source.invite_today_reward }}</span><span>{{ $t('今日返佣') }}</span>
						</div>
						<div><span class="amount">{{ source.invite_month_reward }}</span><span>{{ $t('本月返佣') }}</span>
						</div>
					</section>
				</div>
			</div>

			<div class="line">{{ $t('邀请记录') }}</div>
			<el-tabs style="margin: 0 0 20px;" v-model="tabs" @tab-click="onChange">
				<el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.title"
					:name="item.level"></el-tab-pane>
			</el-tabs>

			<div class="MetaTrader5-bottom-content">
				<div class="trend-head">
					<div class="column">{{ $t('账户') }}</div>
					<div class="column">{{ $t('类型') }}</div>
					<div class="column">{{ $t('返佣金额') }}</div>
					<div class="column">{{ $t('时间') }}</div>
				</div>
				<div class="scroll-wrap">
					<ul class="trend-body">
						<li class="row" v-for="(item, index) in tableData" :key="index">
							<div class="column">{{ item.username }}</div>
							<div class="column">{{ item.type }}</div>
							<div class="column">{{ item.money }}</div>
							<div class="column">{{ item.createtime }}</div>
						</li>
					</ul>
				</div>

				<div class="bottom-more" v-if="tableData.length <= 0">{{ $t('暂无数据') }}</div>

			</div>
			<oPage v-if="tableData.length > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
				:total="page.total" @current-change="getData" />

		</div>


		<el-dialog :visible.sync="show" width="520px" :show-close="false" @open="openDialog">
			<div class="dialog-box">
				<div class="pad-20 txt-ali-rig cur-poi" @click="show = false">
					<i class="el-icon-error txt-32"></i>
				</div>
				<div class="content">
					<h3>{{ $t('想拥有') }} <span>{{ $t('加密货币吗？') }}</span></h3>
					<p>{{ $t('和我们一起开启加密货币之旅') }}</p>
				</div>

				<div class="card-div">
					<div id="qrcode" class="qrcode"></div>
					<div class="but" @click="downloadImagesByParent">{{ $t('保存到本地') }}</div>
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import { mapState } from "vuex";
import {
	get
} from '@/http/request'
import apis from '@/http/api';
import oPage from '@/common/pc/oPage.vue'
import QRCode from 'qrcodejs2';

const qrcodeID = 'qrcode'

export default {
	components: {
		oPage
	},
	data() {
		return {
			tabs: '0',
			tabList: [],
			tableData: [],
			quantity: '',
			source: {},

			show: false,
			page: {
				page: 1,
				limit: 10,
				total: 100,
			}
		};
	},
	computed: {
		...mapState(["shareUrl"]),
	},
	mounted() {
		this.quantity = this.shareUrl.split('=')[1].split('&')[0]
		this.getTeamData()
	},
	beforeUnmount() { },
	methods: {
		async getTeamData() {
			const res = await get(apis.getTeamData, { showLoading: false })
			if (res.code == 1) {
				// console.log(res.data, '44444');
				this.source = res.data
				let arr = res.data.user_count || []
				this.tabList = arr.map(item => {
					item.level = String(item.level)
					return item
				}) || []

				if (this.tabList.length > 0) {
					this.tabs = this.tabList[0].level
					this.getData()
				}
				return
			}
		},
		async getData() {
			const res = await get(apis.getInviteList, {
				...this.page,
				level: this.tabs
			})
			if (res.code == 1) {
				// console.log(res.data.list, '44444');
				this.users = res.data.list
				this.page.total = res.data.total
				return
			}
		},

		onChange() {
			this.getData()
		},
		//复制
		copyText(text) {
			const input = document.createElement('input')
			input.value = text
			document.body.appendChild(input)
			input.select()
			document.execCommand('copy') // 执行复制
			document.body.removeChild(input)
			this.$notify.success('复制成功！') // 如果有 element-ui
		},
		openDialog() {
			this, this.$nextTick(() => {
				this.qRCodeS(this.shareUrl)
			})
		},
		qRCodeS(text) {
			const parent = document.getElementById(qrcodeID)
			parent.innerHTML = ''
			this.$nextTick(() => {
				new QRCode(qrcodeID, {
					text, // 二维码内容
					width: 140,
					height: 140,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				});
			})
		},
		downloadImagesByParent() {
			const parent = document.getElementById(qrcodeID);
			if (!parent) return console.error('父元素不存在');

			const images = parent.getElementsByTagName('img'); // 获取所有 img
			Array.from(images).forEach((img, index) => {
				const url = img.src;
				const filename = `image_${index + 1}.jpg`; // 自动生成文件名
				fetch(url)
					.then(res => res.blob())
					.then(blob => {
						const blobUrl = window.URL.createObjectURL(blob);
						const a = document.createElement('a');
						a.href = blobUrl;
						a.download = filename;
						document.body.appendChild(a);
						a.click();
						a.remove();
						window.URL.revokeObjectURL(blobUrl);
					})
					.catch(err => console.error('下载失败:', err));
			});
		}

	},
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__nav-wrap::after {
	height: 1px;
	background-color: #232437 !important;
}

::v-deep .el-tabs__header {
	margin: 0px;
}

::v-deep .el-tabs__item.is-active {
	color: #fff !important;
}

::v-deep .el-tabs__item {
	font-size: 14px !important;
	font-weight: 500 !important;
	color: #888 !important;
}

::v-deep .el-tabs__active-bar {
	background-color: #fff !important;
}

::v-deep .el-dialog {
	.el-dialog__header {
		padding: 0px;
	}

	.el-dialog__body {
		padding: 0px;
	}
}

.dialog-box {
	height: 430px;
	background: url('~@/assets/img-pc/121.644f197e.jpg') no-repeat;
	background-size: 100% 100%;
	border-radius: 16px;
	position: relative;

	.card-div {
		position: absolute;
		bottom: 30px;
		right: 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 160px;

		.qrcode {
			border-radius: 8px;
			border: 2Px solid #53bd68;
			padding: 8px;
			background-color: #fff;
		}

		.but {
			width: 100%;
			align-items: center;
			justify-content: center;
			display: flex;
			height: 36px;
			line-height: 15px;
			padding: 0 30px;
			border-radius: 99px;
			background: #00f0ff;
			font-size: 16px;
			color: #000;
			cursor: pointer;
			margin-top: 20px;
		}
	}

	.content {
		color: #fff;
		margin-left: 40px;
		margin-top: 10px;

		h3 {
			font-size: 26px;
			font-weight: 700;
			color: #fff;

			span {
				color: #f2c017;
			}
		}

		p {
			font-size: 16px;
		}
	}
}

.bit-center-wrap {
	width: 1360px;
	max-width: 90%;
	margin: 0 auto;
}

.customer-page {
	padding: 0 0 45px;
	min-height: 100%;

	.customer-top {
		position: relative;
		margin: 80px 0 10px;
		background-color: #000;
		display: flex;
		justify-content: space-between;

		.customer-left-content {
			h1 {
				width: 100%;
				font-weight: 700;
				font-size: 48px;
				line-height: 48px;
				color: #fff;
				margin: 0 0 20px;
				z-index: 2;
				display: flex;
				align-items: center;
			}

			h4 {
				color: #888;
				font-weight: 500;
				font-size: 16px;
				z-index: 2;
				margin-bottom: 36px;
			}

			img {
				width: 100%;
			}
		}

		.customer-right-content {
			width: 700px;
			background: #1f1f2f;
			border-radius: 12px;
			border: 2px solid #2c2c3e;
			padding: 40px;

			.amount-row {
				display: flex;
				align-items: center;
				width: 100%;
				height: 60px;
				border-radius: 12px;
				background: #000;
				color: #fff;
				padding-left: 20px;
				margin-bottom: 30px;

				.title {
					font-size: 14px;
					color: #c8c9cc;
				}

				.desc {
					flex: 1;
					text-align: right;
					margin: 0 5px;
					font-size: 13px;
					padding-left: 10%;
				}

				.svg-containe {
					color: #000;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 10px;
					background: #00f0ff;
					width: 90px;
					height: 100%;
					margin-left: 10px;
				}
			}

			.create-qrcode {
				position: relative;
				width: 100%;
				height: 70px;
				line-height: 70px;
				text-align: center;
				font-weight: 700;
				font-size: 14px;
				margin: 70px 0 0;
				cursor: pointer;
				color: #000;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 10px;
				background: #00f0ff;

				.icon-qrcode {
					width: 18px;
					height: 18px;
					margin-right: 10px;
					margin-bottom: 2px;
				}
			}

			.tips-cont {
				margin: 40px auto 20px;
				font-size: 18px;
				color: #fff;
				font-weight: 500;
			}

			.my-invite {
				display: flex;
				width: 100%;
				border-radius: 20px;
				border: 1px solid #2c2c3e;
				height: 240px;

				div {
					width: 50%;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					span {
						height: 45px;
						line-height: 45px;
						text-align: center;
						font-size: 24px;
						color: #fff;
					}

					span:nth-of-type(2) {
						display: flex;
						align-items: center;
						font-size: 14px;
						line-height: 15px;
						color: #888;
					}
				}
			}
		}
	}

	.line {
		margin: 20px auto 30px;
		position: relative;
		font-size: 20px;
		color: #fff;
	}

	.MetaTrader5-bottom-content {
		text-align: center;
		margin-top: 10px;
		background-color: #1c222c;

		.trend-head {
			height: 60px;
			line-height: 60px;
			font-size: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 2px;
			color: #999;
			border-bottom: 1px solid #2c2c3e;
			font-weight: 700;

			.column {
				flex: 1;
			}
		}

		.scroll-wrap {
			.trend-body {
				.row {
					display: flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 2px;
					font-size: 16px;
				}

				.column {
					flex: 1;
					min-height: 60px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}

			ol,
			ul {
				list-style: none;
			}
		}

		.bottom-more {
			width: 100%;
			height: 60px;
			line-height: 60px;
			text-align: center;
			color: #fff;
			font-size: 16px;

		}
	}
}
</style>